import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import useStore from '@/utils/store/common';
import { FilterGroup } from 'ctp-filter-group-management';
import Notification from '@/components/common/Notification/Notification.vue';
import './styles/filter-bookmarks.scss';


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterBookmarks',
  emits: ['applyBookmark'],
  setup(__props, { emit }) {

const store = useStore();

const showBookmarks = ref(false);

const getBookmarks = computed(() => store.getters['groupManagement/getGroups']);
const masterAccount = computed(() => store.getters['user/getSelectedMasterAccount']);
const isOpen = computed(() => showBookmarks.value);

const notificationContent = ref('');
const notificationStatus = ref('');
const isNotificationOpen = ref(false);

watch(masterAccount, (newMaster) => {
  if (newMaster && newMaster.id > 0) {
    store.dispatch('groupManagement/fetchFilterGroups');
  }
}, { immediate: true });

function toggleBookmarks() {
  showBookmarks.value = !showBookmarks.value;
}

function selectBookmark(bookmark: FilterGroup) {
  toggleBookmarks();
  emit('applyBookmark', bookmark);
}

async function deleteBookmark(id: string) {
  const res = await store.dispatch('groupManagement/deleteFilterGroup', [parseInt(id, 10)]);
  store.dispatch('groupManagement/fetchFilterGroups');
  notificationStatus.value = res.notificationStatus;
  notificationContent.value = res.notificationStatus;
  isNotificationOpen.value = true;
}

function closeNotification() {
  isNotificationOpen.value = false;
  notificationContent.value = '';
  notificationStatus.value = '';
}


return { __sfc: true,store, emit, showBookmarks, getBookmarks, masterAccount, isOpen, notificationContent, notificationStatus, isNotificationOpen, toggleBookmarks, selectBookmark, deleteBookmark, closeNotification, Notification }
}

})